import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <CardsSection />
        <TopicsSection />
        <FeaturesSection />
        <CarouselSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
        <FAQSection />
        <IndexSection />
        <AppSection />
        <ContactSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}